export default "__VITE_ASSET__aa908504__"